export default __webpack_public_path__ + "static/media/after_hours.40a48b13.svg";